/** Seattle Twilio Media URLs require Basic auth — proxy through the Flask server. */

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

function isTwilioMediaUrl(url) {
  try {
    const parsed = new URL(url);
    return (
      parsed.hostname === "api.twilio.com" &&
      parsed.pathname.includes("/Media/")
    );
  } catch {
    return false;
  }
}

/**
 * For Seattle, rewrite Twilio Media URLs to the authenticated server proxy.
 * App (and non-Twilio URLs) are returned unchanged.
 */
export function resolveMediaUrl(url, subdomain, authToken) {
  if (!url || subdomain !== "seattle" || !isTwilioMediaUrl(url)) {
    return url;
  }

  const params = new URLSearchParams({ url });
  if (authToken) {
    params.set("token", authToken);
  }
  return `${API_URL}/api/twilio-media?${params}`;
}
